import React, { useState } from 'react';
import ConfirmationBlock from '../ConfirmationBlock';
import deleteImg from '../../../assets/images/warning-gif.gif';
import confirmImg from '../../../assets/images/confirm-gif.gif';
import Button from '../../molecules/Button';
import { useLocation, useNavigate } from 'react-router-dom';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../Context/authContext';
import Toast from '../../molecules/Toast';
import linkedinService from '../../../services/linkedinService';

const DeleteList = ({ leadId, onClose, onSuccess }) => {
  const navigate = useNavigate();

  const [confirmDelete, setConfirmDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const { refetch } = useContextHook(AuthContext, v => ({
    refetch: v.refetch,
  }));

  const handleDeleteList = async _ => {
    try {
      setLoading(true);
      const res = await linkedinService.deleteUserLead(leadId);
      if (res?.success) {
        Toast({ type: 'success', message: res?.message });
        setConfirmDelete(true);
      }
    } catch (error) {
      Toast({ type: 'error', message: error?.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {!confirmDelete ? (
        <ConfirmationBlock
          img={deleteImg}
          title="Delete this Lead!"
          description="Are you sure you want to delete this Lead? This action cannot be undone."
          btns={
            <>
              <Button onClick={() => onClose()}>Cancel</Button>
              <Button
                variant="danger"
                onClick={e => {
                  handleDeleteList();
                }}
                loader={loading}>
                Delete
              </Button>
            </>
          }
        />
      ) : (
        <ConfirmationBlock
          img={confirmImg}
          title="Lead Deleted Successfully!"
          btns={
            <Button
              onClick={() => {
                if (onSuccess) {
                  onSuccess();
                }
                onClose();
              }}>
              Go Back
            </Button>
          }
        />
      )}
    </div>
  );
};

export default DeleteList;
